import { find } from 'lodash/fp';
import getAgrIncomeThresholds from '@ahmdigital/logic/lib/utils/get-agr-income-thresholds';
import getIncomeTypeFromScale from '@ahmdigital/logic/lib/utils/get-income-type-from-scale';

// @ts-expect-error - Automatic, Please fix when editing this file
const calculateIncomeTier = ({ scale, income }) => {
  const incomeType = getIncomeTypeFromScale(scale);
  const thresholds = getAgrIncomeThresholds()[incomeType];
  const threshold = find((obj) => income >= obj.min && income <= obj.max, thresholds);
  const { incomeTier } = threshold;

  return incomeTier;
};

export default calculateIncomeTier;
